import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface AdminUser {
  id: string;
  name: string;
  email: string;
  isAdmin: boolean;
  locale: string;
}

export interface AuthState {
  accessToken: string | null;
  user: AdminUser | null;
  setSession: (token: string, user: AdminUser) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      user: null,
      setSession: (accessToken, user) => set({ accessToken, user }),
      clear: () => set({ accessToken: null, user: null }),
    }),
    {
      name: 'gelirgider-admin-auth',
      storage: createJSONStorage(() => localStorage),
      // Access token is intentionally kept in memory only — refresh interceptor
      // recovers session via the httpOnly refresh cookie on reload. Only the
      // user profile is persisted so the shell can render before /auth/refresh
      // resolves.
      partialize: (state) => ({ user: state.user }),
    },
  ),
);
